import React from 'react';
import { motion } from 'framer-motion';
import { Skill } from './Skill/Skill';
import { aboutAnim, iconsAnim, nameAnim } from './About.anim';
import { SKILLS } from './About.constants';
import { useChangeDocumentTitle } from '../../helpers/useChangeDocumentTitle';

export default function About({ pageTitle }) {
  useChangeDocumentTitle(pageTitle);

  return (
    <motion.section
      className='about'
      variants={aboutAnim}
      initial='init'
      animate='anim'
      exit='end'
    >

      <motion.h3 variants={iconsAnim} className=''>Welcome !</motion.h3>

      <h1 className='text-white' style={{margin: "12px"}}></h1>
      <motion.h5 variants={iconsAnim}>
        - Blockchain Developer -<br />
        {Math.random() < 0
          ? 'Dream it possible!'
          : 'Genius is 1% inspiration and 99% perspiration'}
      </motion.h5>

      <motion.div className='skillsContainer' variants={iconsAnim}>
        {SKILLS.map((skill) => (
          <Skill key={skill.name} name={skill.name} icon={skill.icon} />
        ))}
      </motion.div>
    </motion.section>
  );
}
